import AbstractCRMApi from '../../AbstractCRMApi';

import { SelectOptions } from 'components/common/SelectInput';

class PaymentMethodsApi extends AbstractCRMApi {
    protected endpoint: string = 'payment_method';

    public async getNames(): Promise<SelectOptions> {
        return (await this.get('/names')).data;
    }
}

export default new PaymentMethodsApi();
